export enum Portal {
    BellesDemeures = 'BellesDemeures',
    Immonet = 'Immonet',
    ImmoWeb = 'ImmoWeb',
    ImmoWelt = 'ImmoWelt',
    ImmoWeltAu = 'ImmoWeltAu',
    LaCoteImmo = 'LaCoteImmo',
    LogicImmo = 'LogicImmo',
    LogicImmoConstruire = 'LogicImmoConstruire',
    LogicImmoNeuf = 'LogicImmoNeuf',
    LuxeResidence = 'LuxeResidence',
    MeilleursAgents = 'MeilleursAgents',
    SeLoger = 'SeLoger',
    SeLogerBureauxCommerces = 'SeLogerBureauxCommerces',
    SeLogerConstruire = 'SeLogerConstruire',
    SeLogerNeuf = 'SeLogerNeuf',
}
